<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="机器IP" class="mb-0">
							<el-input size="small" v-model="from.name" ></el-input>
						</el-form-item>
						
						

						
                       <el-form-item label="状态" class="mb-0">
							<el-select v-model="from.status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option label="测试" :value="0"></el-option>
								<el-option label="正式" :value="1"></el-option>
								<el-option label="停用" :value="2"></el-option>
								<el-option label="待停用" :value="3"></el-option>
							</el-select>
						</el-form-item>
						
						
						<el-form-item label="平台" class="mb-0">
							<el-select v-model="from.cloud_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" :value="-1">
								</el-option>
								<el-option v-for="item in agentData.cloud" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item label="客户" class="mb-0">
							<el-select v-model="from.uid" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" :value="-1">
								</el-option>
								<el-option v-for="item in agentData.user" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="销售员" class="mb-0">
							<el-select v-model="from.agent_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" :value="-1">
								</el-option>
								<el-option v-for="item in agentData.agent" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="供应商" class="mb-0">
							<el-select v-model="from.supplier_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option v-for="item in agentData.provider_supplier" :key="item.id" :label="formatSupplierLabel(item)" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="子供应商" class="mb-0">
							<el-select v-model="from.sup_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option v-for="item in agentData.supplier" :key="item.id" :label="formatSupplierLabel(item)" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item label="机器地区" class="mb-0">
							<el-select v-model="from.up_type" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" :value="-1">
								</el-option>
								<el-option v-for="item in agentData.up" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						
						<!-- <el-form-item label="机器配置" class="mb-0">
							<el-input size="small" v-model="from.hardware" ></el-input>
						</el-form-item> -->
						
						<el-form-item label="综合搜索" class="mb-0">
							<el-input size="small" v-model="from.info" ></el-input>
						</el-form-item>
						
						
						
						
						<el-form-item label="创建时间"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item>

						<el-form-item label="账单月份" class="mb-0">
							<el-date-picker
								size="small"
								v-model="from.summary_month"
								type="month"
								value-format="yyyy-MM"
								placeholder="选择月份">
							</el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
				
					</el-form>
					<div class="server-toolbar">
						<div class="server-summary">
							<span>总销售金额：<b>{{formatMoney(serverSummary.total_sales)}}</b></span>
							<span>总成本：<b>{{formatMoney(serverSummary.total_cost)}}</b></span>
						</div>
						<el-button size="small" @click="openModel(false)" v-auth="'add'+auth_val" >添加服务器</el-button>
						<el-button size="small" type="warning" @click="openResetBillModel">数据重跑</el-button>
						<el-button size="small" type="success" icon="el-icon-download" :loading="serverExcelLoading" @click="downServerExcel">导出Excel</el-button>
					</div>
			</template>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2 zj_div" style="padding-bottom:20px">
			<el-table :data="tableData" style="width: 100%" size="mini" @selection-change="handleSelectionChange">
				
				
				<el-table-column width="100" align="center" prop="cloud_name" label="机器平台">
				</el-table-column>
				
				
				<el-table-column show-overflow-tooltip=""  align="center" prop="urgent_remark" width="120" label="紧急备注">
					<template slot-scope="scope">
						<pre style="color: red;">{{scope.row.urgent_remark}}</pre>
					</template>
				</el-table-column>
				
				
				<el-table-column show-overflow-tooltip=""  align="center" prop="tg_info" width="120" label="机器TG">
					<template slot-scope="scope">
						<pre>{{scope.row.tg_info}}</pre>
					</template>
				</el-table-column>
				
				
				
				
				
				<el-table-column v-if="layout.user.type==1"  align="center" prop="account_status" width="100" label="状态">
					<template slot-scope="scope">
						<span style="color: gray;" v-if="scope.row.status==0">测试</span>
						<span class="text-success" v-if="scope.row.status==1">正式</span>
						<span class="text-warning" v-if="scope.row.status==2">停用</span>
						<span class="text-warning" v-if="scope.row.status==3">待停用</span>
						<!-- <el-dropdown  @command="changeAcStatusApi">
						  <el-button  size="mini" :type="getBtnType(scope.row.status)" plain>
						    <span v-if="scope.row.status==0">测试</span>
							<span v-if="scope.row.status==1">正式</span>
							<span v-if="scope.row.status==2">停用</span>
				
							<i class="el-icon-arrow-down el-icon--right"></i>
						  </el-button>
						  <el-dropdown-menu slot="dropdown">
						    <el-dropdown-item :disabled="scope.row.status==0?true:false" :command="{ id: scope.row.id, status: 0 }">测试</el-dropdown-item>
						    <el-dropdown-item :disabled="scope.row.status==1?true:false" :command="{ id: scope.row.id, status: 1 }">正式</el-dropdown-item>
						    <el-dropdown-item :disabled="scope.row.status==2?true:false" :command="{ id: scope.row.id, status: 2 }">停用</el-dropdown-item>
						
						  </el-dropdown-menu>
						</el-dropdown> -->
					</template>
				</el-table-column>
				
				
				
				<el-table-column align="center"  prop="ip" width="120" label="机器IP">
				</el-table-column>
				
				
				<el-table-column   align="center" prop="hardware" width="200" label="机器配置">
					<template slot-scope="scope">
						<pre>{{scope.row.hardware}}</pre>
					</template>
				</el-table-column>
				
				<el-table-column show-overflow-tooltip=""  align="center" prop="info" width="200" label="机器信息">
					<template slot-scope="scope">
						<pre>{{scope.row.info}}</pre>
					</template>
				</el-table-column>
				
				<el-table-column align="center" prop="open_date" width="120" label="开机日期">
				</el-table-column>
				
			
				
				<el-table-column align="center" width="140" prop="user_name" label="客户">
					<template slot-scope="scope">
						<el-link @click="layout.openUserInfo(scope.row.uid)" type="primary" class="text_chengse">{{scope.row.user_name}}</el-link>
						
					</template>
				</el-table-column>
				
				
				<el-table-column align="center" prop="open_date" width="120" label="机器地区">
					<template slot-scope="scope">
						<span  v-for="item in agentData.up" :key="item.id" v-if="scope.row.up_type==item.id">{{item.name}}</span>
						
					
					</template>
				</el-table-column>
				
				
				<el-table-column align="center" prop="new_price" width="120" label="销售价">
					<template slot-scope="scope">
						<span v-if="scope.row.price_type==2" class="text-warning">待定价</span>
						<span v-else>{{scope.row.new_price}}</span>
					</template>
				</el-table-column>
		
			
				
				<el-table-column align="center" prop="cost" width="120" label="成本价">
				</el-table-column>

				<el-table-column align="center" prop="temp_price" width="120" label="临时金额">
					<template slot-scope="scope">
						<div>{{scope.row.temp_price || 0}}</div>
						<div v-if="scope.row.temp_price_month" class="text-muted">{{scope.row.temp_price_month}}</div>
					</template>
				</el-table-column>
				
				
				
				<el-table-column align="center" prop="agent_name" width="120" label="销售员">
				</el-table-column>

				<el-table-column align="center" prop="provider_supplier_name" width="120" label="供应商">
				</el-table-column>

				<el-table-column align="center" prop="supplier_name" width="120" label="子供应商">
				</el-table-column>
				
				
				
				
			
				
				
				
				<el-table-column show-overflow-tooltip=""  align="center" prop="remark" width="120" label="备注">
					<template slot-scope="scope">
						<pre >{{scope.row.remark}}</pre>
					</template>
				</el-table-column>
			
				<el-table-column show-overflow-tooltip=""  align="center" prop="user_remark" width="120" label="客户备注">
					<template slot-scope="scope">
						<pre>{{scope.row.user_remark}}</pre>
					</template>
				</el-table-column>
				
				
				
				
				<el-table-column align="center" prop="pay_type" width="150" label="付费类型">
					<template slot-scope="scope">
						<div v-if="scope.row.pay_type==2">
							<div>预付费</div>
							<div v-if="scope.row.type_end" class="text-muted">{{scope.row.type_end}}</div>
						</div>
						<span v-else>后付费</span>
					</template>
				</el-table-column>
				
				<el-table-column align="center"  prop="pro_name" :label="$t('model.log')">
					<template slot-scope="scope">
						<el-link @click="checkLog(scope.row.id)" type="info">{{$t('accountList.check')}}</el-link>
					</template>
				</el-table-column>
				
				<el-table-column show-overflow-tooltip=""  align="center" prop="create_time" width="160" label="创建时间">
				</el-table-column>
                
				
				<el-table-column align="center" width="90" fixed="right" :label="$t('layout.operation')">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" plain type="success" v-auth="'edit'+auth_val"  @click="openModel(scope)">{{$t('cdnd.edit')}}</el-button>
							<!-- <el-button @click="deleteItem(scope.row)" v-auth="'delAdmin'" size="mini" plain type="danger">{{$t('layout.delete')}}</el-button> -->
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>



		<el-footer
		class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		:style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		>
			<div style="flex: 1;" class="px-2">
				<el-pagination
				:current-page="page.current"
				:page-sizes="page.sizes"
				:page-size="page.size"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				background
				:layout="layout.is_phone ? 'total, prev, pager, next, jumper' : 'total, prev, pager, next, sizes, jumper'"
				:total="page.total"
				/>
			</div>
		</el-footer>

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? '修改服务器' : '添加服务器'"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				
				<el-row>
					
					<el-col :span="8">
						<el-form-item  label="开机平台" prop="cloud_id">
							<el-select style="width: 85%;"   v-model="form.cloud_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option v-for="item in agentData.cloud" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
					</el-col>
					<el-col :span="8">
						<el-form-item  label="客户" prop="uid">
							<el-select :disabled="editIndex>0 && layout.user.type!=1" style="width: 85%;"  v-model="form.uid" size="small" filterable :placeholder="$t('system.select')">
								<el-option v-for="item in agentData.user" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
					</el-col>
					<el-col :span="8">
						<el-form-item  label="销售员" prop="agent_id">
							<el-select :disabled="editIndex>0 && layout.user.type!=1" style="width: 85%;"  v-model="form.agent_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option v-for="item in agentData.agent" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
					</el-col>

					<el-col :span="8">
						<el-form-item label="供应商" prop="supplier_id">
							<el-select style="width: 85%;" v-model="form.supplier_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option v-for="item in agentData.provider_supplier" :key="item.id" :label="formatSupplierLabel(item)" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>

					<el-col :span="8">
						<el-form-item label="子供应商" prop="sup_id">
							<el-select style="width: 85%;" v-model="form.sup_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option v-for="item in agentData.supplier" :key="item.id" :label="formatSupplierLabel(item)" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					
					<el-col :span="24">
						<el-divider  class="mt-1">服务器信息</el-divider>
					</el-col>
					
					<el-col :span="8">
						<el-form-item label="IP" prop="ip">
							<el-input  v-model="form.ip"  clearable size="small" placeholder="请输入机器IP"  style="width: 85%;"></el-input>
						</el-form-item>
						
					</el-col>
					
					<!-- <el-col :span="6">
						<el-form-item label="端口" prop="port">
							<el-input v-model="form.port"  clearable size="small" placeholder=""  style="width: 85%;"></el-input>
						</el-form-item>
						
					</el-col>
					
					<el-col :span="6">
						<el-form-item label="登录名" prop="username">
							<el-input v-model="form.username"  clearable size="small" placeholder=""  style="width: 85%;"></el-input>
						</el-form-item>
						
					</el-col>
					
					<el-col :span="6">
						<el-form-item label="密码" prop="password">
							<el-input v-model="form.password"  clearable size="small" placeholder=""  style="width: 85%;"></el-input>
						</el-form-item>
						
					</el-col>
					
					
					<el-col :span="6">
						<el-form-item label="CPU" prop="cpu">
							<el-input v-model="form.cpu" type="number"  clearable size="small" placeholder=""  style="width: 85%;">
								<template slot="append">核</template>
							</el-input>
						</el-form-item>
						
					</el-col>
					
					<el-col :span="6">
						<el-form-item label="内存" prop="men">
							<el-input v-model="form.men" type="number"  clearable size="small" placeholder=""  style="width: 85%;">
								<template slot="append">GB</template>
							</el-input>
						</el-form-item>
						
					</el-col>
					
					<el-col :span="6">
						<el-form-item label="带宽" prop="band">
							<el-input v-model="form.band" type="number"  clearable size="small" placeholder=""  style="width: 85%;">
								<template slot="append">MB</template>
							</el-input>
						</el-form-item>
						
					</el-col>
					
					<el-col :span="6">
						<el-form-item label="磁盘" prop="ssd">
							<el-input v-model="form.ssd" type="number"  clearable size="small" placeholder=""  style="width: 85%;">
								<template slot="append">GB</template>
							</el-input>
						</el-form-item>
						
					</el-col> -->
					
					
					<el-col :span="8">
						
						<el-form-item label="开机日期" prop="open_date">
					
							   <el-date-picker
							   size="small"
							        v-model="form.open_date"
								  value-format="yyyy-MM-dd"
								  format="yyyy-MM-dd"
							        type="date"
							        :placeholder="$t('orderList.selDate')">
							      </el-date-picker>
						</el-form-item>
						
						
					</el-col>
					
					<el-col :span="8">
						<el-form-item  label="机器地区" prop="up_type">
							<el-select style="width: 85%;"  v-model="form.up_type" size="small" filterable :placeholder="$t('system.select')">
								
								
								<el-option v-for="item in agentData.up" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
								
							</el-select>
						</el-form-item>
						
					</el-col>
					
					
					
					<el-col :span="8">
						<el-form-item label="机器信息" prop="info">
							<el-input  :rows="4" type="textarea" v-model="form.info"   clearable size="small" placeholder=""  style="width: 85%;">
								
							</el-input>
						</el-form-item>
						
					</el-col>
					
					<el-col :span="8">
						<el-form-item label="机器配置" prop="hardware">
							<el-input  :rows="4" type="textarea" v-model="form.hardware"   clearable size="small" placeholder=""  style="width: 85%;">
								
							</el-input>
						</el-form-item>
						
					</el-col>
					
					<el-col :span="8">
						<el-form-item label="机器TG群" prop="tg_info">
							<el-input  :rows="4" v-model="form.tg_info" type="textarea"   clearable size="small" placeholder=""  style="width: 85%;">
								
							</el-input>
						</el-form-item>
					</el-col>
					
					<el-col :span="24">
						<el-divider class="mt-1">其他信息</el-divider>
					</el-col>
					
					<el-col :span="9">
						<el-form-item label="价格类型" prop="price_type">
							<el-radio-group v-model="form.price_type" size="small" @change="changePriceType">
								<el-radio class="mr-1 mb-0" :label="1" border>已知价格</el-radio>
								<el-radio class="mr-1 mb-0" :label="2" border>公云后付费</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					
					<el-col :span="15">
						<el-form-item label="状态" prop="status">
							
							<el-radio-group v-model="form.status" size="small">
								<el-radio class="mr-1 mb-0" :label="0" border>测试</el-radio>
								<el-radio class="mr-1 mb-0" :label="1" border>正式</el-radio>
								<el-radio class="mr-1 mb-0" :label="2" border>停用</el-radio>
								<el-radio class="mr-1 mb-0" :label="3" border>待停用</el-radio>
								
							</el-radio-group>
							
							<el-date-picker v-show="form.status==3"
							size="small"
							class="ml-2"
							style="width: 150px;"
							     v-model="form.end_time"
															  value-format="yyyy-MM-dd"
															  format="yyyy-MM-dd"
							     type="date"
							     :placeholder="$t('orderList.selDate')">
							   </el-date-picker>
						</el-form-item>
					</el-col>

					<el-col v-if="form.price_type==1" :span="12">
						<el-form-item label="成本价" prop="cost">
							<el-input v-model="form.cost" type="number"  clearable size="small" placeholder=""  style="width: 85%;">
								
							</el-input>
						</el-form-item>
					</el-col>
					<el-col v-if="form.price_type==1" :span="12">
						<el-form-item label="销售价" prop="price">
							<el-input v-model="form.price" type="number"  clearable size="small" placeholder=""  style="width: 85%;">
								
							</el-input>
						</el-form-item>
					</el-col>
					
					
					
					
					<el-col :span="8">
						<el-form-item label="客户备注" prop="user_remark">
							<el-input :rows="2" v-model="form.user_remark" type="textarea"   clearable size="small" placeholder=""  style="width: 85%;">
								
							</el-input>
						</el-form-item>
					</el-col>
					
					<el-col :span="8">
						<el-form-item label="备注" prop="remark">
							<el-input :rows="2" v-model="form.remark" type="textarea"   clearable size="small" placeholder=""  style="width: 85%;">
								
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="紧急备注" prop="urgent_remark">
							<el-input :rows="2" v-model="form.urgent_remark" type="textarea"   clearable size="small" placeholder=""  style="width: 85%;">
								
							</el-input>
						</el-form-item>
					</el-col>
					
					<el-col :span="form.price_type==1 ? 12 : 24">
						<el-form-item label="付费类型" prop="type_end">
							<div style="display: flex; align-items: center; flex-wrap: nowrap; white-space: nowrap;">
								<el-radio-group v-model="form.pay_type" size="small" style="flex-shrink: 0;" @change="changePayType">
									<el-radio class="mr-1 mb-0" :label="1" border>后付费</el-radio>
									<el-radio class="mr-1 mb-0" :label="2" border>预付费</el-radio>
								</el-radio-group>
								<el-date-picker v-if="form.pay_type==2"
									size="small"
									style="width: 150px; flex-shrink: 0; margin-left: 8px;"
									v-model="form.type_end"
									value-format="yyyy-MM-dd"
									format="yyyy-MM-dd"
									type="date"
									placeholder="预付费结束日期">
								</el-date-picker>
							</div>
						</el-form-item>
					</el-col>
					
					<el-col v-if="form.price_type==1" :span="5">
						<el-form-item label="增值金额" prop="add_price">
							<el-input v-model="form.add_price" type="number"  clearable size="small" placeholder=""  style="width: 100%;">
								
							</el-input>
						</el-form-item>
					</el-col>
					
					<el-col v-if="form.price_type==1" :span="7">
						<el-form-item label="增值备注" prop="add_remark">
							<el-input :rows="2" v-model="form.add_remark" type="textarea"   clearable size="small" placeholder=""  style="width: 100%;">
								
							</el-input>
						</el-form-item>
					</el-col>

					<el-col v-if="form.price_type==1" :span="5">
						<el-form-item label="临时金额" prop="temp_price">
							<el-input v-model="form.temp_price" type="number" clearable size="small" placeholder="" style="width: 100%;"></el-input>
						</el-form-item>
					</el-col>

					<el-col v-if="form.price_type==1" :span="7">
						<el-form-item label="临时账单月" prop="temp_price_month">
							<el-date-picker
								v-model="form.temp_price_month"
								type="month"
								value-format="yyyy-MM"
								format="yyyy-MM"
								size="small"
								style="width: 100%;"
								placeholder="默认上月">
							</el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
				
              
               
				
			
                
                
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">{{$t('system.cancel')}}</el-button>
				<el-button type="primary" :loading="layout.loading" :disabled="layout.loading" @click="submit">{{$t('system.confirm')}}</el-button>
			</div>
		</el-dialog>

		<el-dialog :close-on-click-modal="false"
			title="云服务器账单重跑"
			:visible.sync="resetBillModel"
			width="420px"
			:append-to-body="true"
			custom-class="custom-dialog">
			<el-form :rules="resetBillRules" ref="resetBillFormRef" :model="resetBillForm" label-width="90px">
				<el-form-item label="账单月份" prop="month">
					<el-date-picker
						size="small"
						style="width: 100%;"
						v-model="resetBillForm.month"
						type="month"
						value-format="yyyy-MM"
						format="yyyy-MM"
						placeholder="请选择账单月份">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="客户" prop="uid">
					<el-select style="width: 100%;" v-model="resetBillForm.uid" size="small" filterable placeholder="请选择客户">
						<el-option label="全部客户" :value="0"></el-option>
						<el-option v-for="item in agentData.user" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div style="font-size: 12px; color: #909399; line-height: 20px;">
				清除所选月份的 FFCloud 云服务器账单和生成标记，并立即按所选月份重新生成。
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="resetBillModel = false">{{$t('system.cancel')}}</el-button>
				<el-button type="warning" :loading="resetBillLoading" :disabled="resetBillLoading" @click="submitResetBill">确认重跑</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			const now = new Date()
			now.setDate(1)
			now.setMonth(now.getMonth() - 1)
			const summaryMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`
			return {
				date:'',
				createModel: false,
				resetBillModel: false,
				resetBillLoading: false,
				serverExcelLoading: false,
				serverSummaryLoading: false,
				serverSummary: {
					month: summaryMonth,
					total_sales: 0,
					total_cost: 0,
					count: 0,
				},
				editIndex: -1,
				agentData:{
					cloud:[],
					provider_supplier: [],
					supplier: [],
				},
				resetBillForm: {
					month: '',
					uid: 0,
				},
				//搜索數据
				from: {
					info: '',
					hardware: '',
					name: '',
					username:'',
					status:-1,
					uid:-1,
					up_type:-1,
					cloud_id:-1,
					agent_id:-1,
					supplier_id:-1,
					sup_id:-1,
					time:[],
					summary_month: summaryMonth,
				},
				auth_val: 'Zjserver',

				preUrl: "data/zjserverList", //列表地址
				// delAllUrl: "user/delAdminAll", //批量删除地址
				delUrl: "data/delServerzj", //删除單条地址
				addUrl: "data/addServerzj", //添加/修改地址
				editStatusUrl:"data/editStatusServerzj",//修改狀態地址

				tableData: [],
				form: {
                    
				},
				rules: {
					cloud_id: [{
						required: true,
						message: '请选择开机平台',
						trigger: 'blur',
					}],
					uid: [{
						required: true,
						message: '请选择客户',
						trigger: 'blur',
					}],
					agent_id: [{
						required: true,
						message: '请选择销售员',
						trigger: 'blur',
					}],
					supplier_id: [{
						required: true,
						validator: (rule, value, callback) => {
							if (!value || Number(value) <= 0) {
								return callback(new Error('请选择供应商'));
							}
							callback();
						},
						trigger: 'change',
					}],
					sup_id: [{
						required: true,
						validator: (rule, value, callback) => {
							if (!value || Number(value) <= 0) {
								return callback(new Error('请选择子供应商'));
							}
							callback();
						},
						trigger: 'change',
					}],
					ip: [{
						required: true,
						message: '请输入机器IP',
						trigger: 'blur',
					}],
					up_type: [{
						required: true,
						message: '请选择机器地区',
						trigger: 'blur',
					}],
					open_date: [{
						required: true,
						message: '请选择开机日期',
						trigger: 'blur',
					}],
					cost: [{
						validator: (rule, value, callback) => {
							if (this.form.price_type != 2 && (value === '' || value === null || value === undefined)) {
								return callback(new Error('请输入成本价'));
							}
							if (this.form.price_type != 2 && this.form.price !== '' && this.form.price !== null && this.form.price !== undefined && Number(this.form.price) < Number(value)) {
								return callback(new Error('销售价不能小于成本价'));
							}
							callback();
						},
						trigger: 'blur',
					}],
					price: [{
						validator: (rule, value, callback) => {
							if (this.form.price_type != 2 && (value === '' || value === null || value === undefined)) {
								return callback(new Error('请输入销售价'));
							}
							if (this.form.price_type != 2 && this.form.cost !== '' && this.form.cost !== null && this.form.cost !== undefined && Number(value) < Number(this.form.cost)) {
								return callback(new Error('销售价不能小于成本价'));
							}
							callback();
						},
						trigger: 'blur',
					}],
					type_end: [{
						validator: (rule, value, callback) => {
							if (this.form.pay_type == 2 && !value) {
								return callback(new Error('请选择预付费结束日期'));
							}
							callback();
						},
						trigger: 'change',
					}],
					
					
				},
				resetBillRules: {
					month: [{
						required: true,
						message: '请选择账单月份',
						trigger: 'change',
					}],
				},
				agent_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			this.commonList('zjserver');
		},
		methods: {
			downServerExcel(){
				this.serverExcelLoading = true
				this.axios.post('/admin/data/serverExcel', {
					search: this.from,
					prop: this.prop,
					sort: this.sort == 'ascending' ? 'asc' : 'desc'
				}, {
					token: true
				}).then(res => {
					let all = res.data
					let list = all.data.list
					const link = document.createElement('a')
					link.href = list
					link.download = ''
					link.target = '_blank'
					document.body.appendChild(link)
					link.click()
					document.body.removeChild(link)
				}).catch(() => {
					this.$message.error(this.$t('system.openFailed'))
				}).finally(() => {
					this.serverExcelLoading = false
				})
			},
			changeAcStatusApi(data){
			
				this.axios.post(this.changeStatusUrl(), {
					id: data.id,
					status: data.status,
					type: 'status',
				}, {
					token: true,
				}).then(res => {
					let all = res.data;
					console.log(all)
					if (all.code == 1) {
						this.$message({
							message:all.msg,
							type: 'success'
						});
						let index  = this.tableData.findIndex(item=>item.id == data.id)
						this.tableData[index].status = data.status
						if(data.status==2){
							this.getList()
						}
					}
					//this.layout.loading = false;
				}).catch(err => {
					//this.layout.loading = false;
					this.$message.error(this.$t('system.openFailed'));
				});
			},
			
			getBtnType(status){
				if(status==1){
					return 'success';
				}else if(status==0){
					return 'info';
				}else if(status==2){
					return 'warning';
				}else{
					return 'info';
				}
			},
			formatSupplierLabel(item) {
				if (!item) return ''
				return item.name || ''
			},
			limitRebate(val) {
			    const n = Number(val)
			    if (!Number.isFinite(n)) { this.form.rebate = null; return }
			    const clamped = Math.min(100, Math.max(0, n))
			    this.form.rebate = Math.trunc(clamped)   // 只要整数
			  },
            validateParent(rule, value, callback) {
                if (this.form.id > 0) {
                    if (!value) {
                        return callback(new Error(this.$t('agentList.passwordLength'))); // 只有 type == 2 时才校验
                    }
                }
                callback(); // 其他情况不校验
            },
			//提交
			submit() {
			
				this.$refs.form.validate(res => {
					// if(!this.form.headUrl){
					// 	this.$message.error(this.$t('agentList.upProfile'));
					// 	return false
					// }
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			changePayType() {
				if (this.form.pay_type != 2) {
					this.form.type_end = ''
				}
				this.$refs.form && this.$refs.form.clearValidate('type_end')
			},
			changePriceType() {
				if (this.form.price_type == 2) {
					this.form.cost = 0
					this.form.price = 0
					this.form.add_price = 0
					this.form.add_remark = ''
					this.form.temp_price = 0
					this.form.temp_price_month = ''
				}
				this.$refs.form && this.$refs.form.clearValidate(['cost', 'price'])
			},
			defaultTempPriceMonth() {
				const date = new Date()
				date.setDate(1)
				date.setMonth(date.getMonth() - 1)
				const year = date.getFullYear()
				const month = String(date.getMonth() + 1).padStart(2, '0')
				return `${year}-${month}`
			},
			
			checkLog(id){
				this.layout.logModel = true
				this.layout.logID = id
				this.layout.logType = 2
			},
			openResetBillModel(){
				this.resetBillForm = {
					month: '',
					uid: 0,
				}
				this.resetBillModel = true
				this.$nextTick(() => {
					this.$refs.resetBillFormRef && this.$refs.resetBillFormRef.clearValidate()
				})
			},
			submitResetBill(){
				this.$refs.resetBillFormRef.validate(res => {
					if (!res) return
					const userText = this.resetBillForm.uid ? '指定客户' : '全部客户'
					this.$confirm(`确认清除 ${this.resetBillForm.month} 的${userText}云服务器账单并立即重跑？`, '提示', {
						confirmButtonText: this.$t('system.confirm'),
						cancelButtonText: this.$t('system.cancel'),
						type: 'warning'
					}).then(() => {
						this.resetBillLoading = true
						this.axios.post('/admin/data/resetServerBillzj', this.resetBillForm, {
							token: true,
							loading: true
						}).then(res => {
							let all = res.data
							if (all.code == 1) {
								this.$message.success(all.msg)
								this.resetBillModel = false
								this.getList()
							} else {
								this.$message.error(all.msg || this.$t('system.openFailed'))
							}
							this.resetBillLoading = false
						}).catch(() => {
							this.resetBillLoading = false
							this.$message.error(this.$t('system.openFailed'))
						})
					}).catch(() => {})
				})
			},

			// 打开模态框
			openModel(e = false) {
				// 增加
				if (!e) {
					// 初始化表單
					this.form = {
						cloud_id:'',
						ip: "",
						port: "",
						username: "",
						password: "",
						up_type: 1,
						uid: '',
						supplier_id: '',
						sup_id: '',
						cpu: 0,
						men: 0,
						ssd: 0,
						band: 0,
						add_price: 0,
						add_remark: '',
						temp_price: 0,
						temp_price_month: this.defaultTempPriceMonth(),
						price_type: 1,
						pay_type: 1,
						type_end: '',
						info: '',
						hardware: '',
						open_date: this.date,
						end_time: this.date,
						cost: '',
						price: '',
						agent_id: '',
						user_remark: '',
						remark: '',
						urgent_remark: '',
						tg_info: '',
						status: 0,

					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						cloud_id:e.row.cloud_id,
						ip: e.row.ip,
						port: e.row.port,
						username: e.row.username,
						password: e.row.password,
						up_type: e.row.up_type,
						uid: e.row.uid,
						supplier_id: e.row.supplier_id || '',
						sup_id: e.row.sup_id || '',
						cpu: e.row.cpu,
						men: e.row.men,
						ssd: e.row.ssd,
						band: e.row.band,
						info: e.row.info,
						hardware: e.row.hardware,
						end_time: e.row.end_time,
						open_date: e.row.open_date,
						cost: e.row.cost,
						price: e.row.price,
						price_type: e.row.price_type || 1,
						agent_id: e.row.agent_id,
						user_remark: e.row.user_remark,
						remark: e.row.remark,
						add_price: e.row.add_price,
						add_remark: e.row.add_remark,
						temp_price: e.row.temp_price || 0,
						temp_price_month: e.row.temp_price_month || '',
						pay_type: e.row.pay_type || 1,
						type_end: e.row.type_end || '',
						urgent_remark: e.row.urgent_remark,
						tg_info: e.row.tg_info,
						status: e.row.status,
						
					}
					this.editIndex = e.row.id
				}
				// 打开dialog
				this.createModel = true
			},
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.agentData = list
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
            handleAvatarSuccessTg(res, file) {
				this.form.tg_qr = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.tgQrUrl = res.encryption.data.list.url
				}
			},
			beforeAvatarUpload(file) {
							const isJPG = file.type === 'image/jpeg';
							const isLt2M = file.size / 1024 / 1024 < 2;
					
							return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.date = e.date
				this.loadServerSummary()
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			loadServerSummary() {
				this.serverSummaryLoading = true
				this.axios.post('/admin/data/serverSummaryzj', {
					search: this.search || this.from,
					month: this.from.summary_month,
				}, {
					token: true
				}).then(res => {
					let all = res.data
					this.serverSummary = all.data.list || {
						month: this.from.summary_month,
						total_sales: 0,
						total_cost: 0,
						count: 0,
					}
					if(this.serverSummary.month){
						this.from.summary_month = this.serverSummary.month
					}
				}).catch(() => {
					this.$message.error(this.$t('system.openFailed'))
				}).finally(() => {
					this.serverSummaryLoading = false
				})
			},
			formatMoney(value) {
				const num = Number(value || 0)
				return Number.isFinite(num) ? num.toFixed(2) : '0.00'
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					info: '',
					hardware: '',
					name: '',
					username:'',
					status:-1,
					uid:-1,
					up_type:-1,
					cloud_id:-1,
					agent_id:-1,
					supplier_id:-1,
					sup_id:-1,
					time:[],
					summary_month: this.defaultTempPriceMonth(),
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}

.zj_div pre{
	font-size: 13px;
	margin-bottom: 0;
	max-height: 100px;
	overflow-y: auto;
}

.server-toolbar{
	margin-top: 10px;
	display: flex;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
}

.server-summary{
	display: inline-flex;
	align-items: center;
	gap: 10px;
	margin-right: 8px;
	padding: 4px 10px;
	border: 1px solid #ebeef5;
	border-radius: 4px;
	background: #f8f9fb;
	color: #606266;
	font-size: 12px;
}

.server-summary b{
	color: #303133;
}
</style>
